export default {
  title: 'Horários e localização',
  set_different_opening_hours: 'Definir horários de abertura diferentes para entrega',
  delivery_opening_hours: 'Horários de entrega',
  sections: {
    general: 'Horários gerais',
    holidays: 'Pausar encomendas (feriados)',
    create_time: 'Adicionar horário de abertura',
    edit_time: 'Editar horário',
    delivery_schedule: 'Horários de entrega',
  },
  tabs: {
    open_times: 'Horários',
    location: 'Localização',
  },
  form: {
    select_all: {
      label: 'Selecionar todos os dias',
    },
    holiday_starts_at: {
      label: 'Data de início',
    },
    holiday_ends_at: {
      label: 'Data de fim',
    },
    has_delivery_schedule: {
      label: 'Definir horários de abertura diferentes para entrega',
    },
    has_multiple_locations: {
      label: 'Definir localizações diferentes para a semana',
    },
  },
  labels: {
    day_location: '{{day}} - localização {{index}}',
    selected_days: 'Dias selecionados',
    orders_paused: 'Encomendas pausadas',
    open_time: 'Hora de abertura',
    close_time: 'Hora de fecho',
  },
  errors: {
    close_time: 'A hora de fecho não pode ser 00:00. Introduza 23:59',
  },
  buttons: {
    edit: 'Editar',
    add_schedule_unit: 'Adicionar horário de abertura',
    add_holiday: 'Adicionar feriado',
    delete: 'Eliminar',
    save: 'Guardar',
    cancel: 'Cancelar',
  },
  toasts: {
    changes_got_saved: 'Informação atualizada com sucesso',
    failed_to_save_changes: 'Erro ao guardar as alterações',
  },
};
